@let tellentHrActive = isTellentHrActive()!;

<tlc-churn-flow-step-template [currentStep]="3" [reasonInfoboxMessage]="infoboxMessage()">
  <div class="left">
    <tlc-churn-flow-reason-template
      [heading]="'tlc.churn_flow.steps.not_hiring.heading' | translate"
      [subheading]="'tlc.churn_flow.steps.not_hiring.subheading' | translate"
      (stayWithTellent)="stayWithTellent()"
      (stillWantToCancel)="stillWantToCancel()"
    >
      <div class="solutions-container">
        <tlc-churn-flow-solution-card
          [iconVariant]="tellentHrSolution.iconVariant"
          [title]="tellentHrSolution.title"
          [subtitle]="tellentHrSolution.subtitle"
          [incentives]="tellentHrSolution.incentives"
          [displayFreeBadge]="true"
          [isHighlighted]="true"
        >
          <div class="additional-content-top">
            @if (!displayYoutubeVideo()) {
              <img
                [ngSrc]="'assets/images/churn-flow/hris-video-thumbnail.png'"
                [width]="300"
                [height]="165"
                alt="hris-video-thumbnail"
                (click)="loadYoutubeVideo()"
              />
            } @else {
              <iframe
                class="video-container"
                width="300"
                height="165"
                [src]="getVideoUrl()"
                title="YouTube video player"
                frameborder="0"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            }
          </div>
          <div class="actions">
            <a
              rt-button
              variant="plain"
              href="https://tellent.com/hr-manage/overview"
              target="_blank"
            >
              <rt-icon name="open-in-new" />
              <span>{{ tellentHrSolution.secondaryCtaText }}</span>
            </a>
            <rt-button
              variant="primary"
              (click)="activateHrFreeTrial()"
              [disabled]="tellentHrActive"
            >
              @if (tellentHrActive) {
                <rt-icon prefix name="check" colorToken="colorIconSuccessDefault" />
              } @else {
                <rt-icon prefix name="open-in-new" />
              }
              <span>{{ tellentHrSolution.ctaText }}</span>
            </rt-button>
          </div>
        </tlc-churn-flow-solution-card>

        <tlc-churn-flow-solution-card
          [iconVariant]="pauseSubscriptionSolution.iconVariant"
          [title]="pauseSubscriptionSolution.title"
          [subtitle]="pauseSubscriptionSolution.subtitle"
          [incentives]="pauseSubscriptionSolution.incentives"
        >
          <div class="actions">
            <rt-button variant="tertiary" (click)="pauseSubscription()">
              <rt-icon name="open-in-new" />
              <span>{{ pauseSubscriptionSolution.ctaText }}</span>
            </rt-button>
          </div>
        </tlc-churn-flow-solution-card>
      </div>
    </tlc-churn-flow-reason-template>
  </div>

  <div class="right">
    <tlc-churn-flow-insights />
  </div>
</tlc-churn-flow-step-template>
